import { render } from "./ConfirmDeleteWorkComponent.vue?vue&type=template&id=8ae8f444"
import script from "./ConfirmDeleteWorkComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteWorkComponent.vue?vue&type=script&lang=js"

import "./ConfirmDeleteWorkComponent.vue?vue&type=style&index=0&id=8ae8f444&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__